import type { VisualizationResult } from '../../types';
import { AnnotatedTextRenderer } from './AnnotatedTextRenderer';
import { MetricCardRenderer } from './MetricCardRenderer';
import { PillBadgeRenderer } from './PillBadgeRenderer';
import { TableRenderer } from './TableRenderer';

interface VisualizationRendererProps {
    /** Visualization data to render */
    visualization: VisualizationResult;
    /** Optional className for custom styling */
    className?: string;
}

/**
 * Main dispatcher component that renders the appropriate visualization
 * based on the `type` discriminator field.
 */
export function VisualizationRenderer({ visualization, className }: VisualizationRendererProps) {
    switch (visualization.type) {
        case 'metric-card':
            return <MetricCardRenderer data={visualization} className={className} />;
        case 'pill-badge':
            return <PillBadgeRenderer data={visualization} className={className} />;
        case 'annotated-text':
            return <AnnotatedTextRenderer data={visualization} className={className} />;
        case 'table':
            return <TableRenderer data={visualization} className={className} />;
        default:
            return null;
    }
}
